import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import {
  selectCategoryHierarchy,
  selectRelatedCategories,
  selectChildCategories,
} from '../../selectors/categoriesSelector'
import { categoriesToCategoryItems } from '../item/categoryTransformers'
import Switch from '../ui/Switch'
import MunicipalitySearchBox from '../widgets/MunicipalitySearchBox'
import { CATEGORY_ID_PAIKALLISUUTISET } from '../../lib/constants'
import './newsListWidgets.pcss'
import { selectUserCategories } from '../../selectors/userSelector'

function NewsListWidgets({ category }) {
  const categoryHierarchy = useSelector((state) => selectCategoryHierarchy(state, category))
  const userCategories = useSelector(selectUserCategories)

  // Get related categories to be shown above news list. For Level 2 categories
  // we automatically use its Level 3 children, if explicit list does not exist
  const relatedCategories = useSelector((state) => {
    const related = selectRelatedCategories(state, category)
    if (related.size === 0 && category && category.treeLevel === 2) {
      return selectChildCategories(state, category)
    }
    return related
  })

  const relatedCategoryItems = categoriesToCategoryItems(relatedCategories, userCategories)

  const renderHierarchy = categoryHierarchy.size === 3
  const renderRelated = !renderHierarchy && relatedCategories && relatedCategories.size > 0
  const renderMunicipalitySearch = categoryHierarchy.getIn([0, 'id']) === CATEGORY_ID_PAIKALLISUUTISET

  return (
    <div className='newslist-widgets'>
      { (renderHierarchy || renderRelated) &&
        <div className='related-categories'>
          { renderHierarchy &&
            <div className='breadcrumbs'>
              <Link to={ '/' + categoryHierarchy.getIn([0, 'slug']) }>{ categoryHierarchy.getIn([0, 'name']) }</Link>
              { ' ' }<i className='fa fa-angle-double-right' aria-hidden='true'></i>{ ' ' }
              <Link to={ '/' + categoryHierarchy.getIn([1, 'slug']) }>{ categoryHierarchy.getIn([1, 'name']) }</Link>
            </div>
          }
          { renderRelated &&
            <h2 className='sr-only'>Alakategoriat</h2>
          }
          { renderRelated &&
            relatedCategoryItems.map((catItem) => (
              <Switch key={ catItem.get('id') } tag={ catItem } />
            ))
          }
        </div>
      }
      { renderMunicipalitySearch &&
        <MunicipalitySearchBox />
      }
    </div>
  )
}

NewsListWidgets.propTypes = exact({
  category: ImmutablePropTypes.record.isRequired,
})

export default NewsListWidgets
